import { Pipe, PipeTransform } from "@angular/core";
import { ContainerReleaseStatus } from "../../pb-screen/models/pb-screen.interface";


@Pipe({name: "secureContainerRelease"})
export class SecureContainerReleaseCaptionPipe implements PipeTransform {
    transform(value: ContainerReleaseStatus): string {

        if (!value) {
            return "";
        }

        switch(value){  

            case ContainerReleaseStatus.Required:
               return "Required" ; 
            case ContainerReleaseStatus.AssignDriverFailed:
                return "Assign Driver Failed"; 
            case ContainerReleaseStatus.AssignDriverSuccessful:
                return "Assign Driver Successful"; 
            case ContainerReleaseStatus.Received:
                return "Received"; 
            case ContainerReleaseStatus.RevokeFailed:
                return "Revoke Failed"; 
            case ContainerReleaseStatus.RevokeSuccess:
                return "Revoke Success"; 
            case ContainerReleaseStatus.Revoked:
                return "Revoked";  
            case ContainerReleaseStatus.TransferSuccessful:
                return "Transfer Successful";
            case ContainerReleaseStatus.TransferFailed:
                return "Transfer Failed";
            case ContainerReleaseStatus.UnassignDriverFailed:
                return "Unassign Driver Failed";
            case ContainerReleaseStatus.UnassignDriverSuccess:
                return "Unassign Driver Success";

            default: 
            return "";
        }
    }
}